import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';
import { GuestContactListComponent } from './guest-contact-list/guest-contact-list.component';

const routes: Routes = [
      {
        path:'list',component:ListComponent
      },
      {
        path:'add',component:AddComponent
      },
      {
        path:'view/:id',component:ViewComponent
      },
      {
        path:'edit/:id',component:AddComponent
      },
      {
        path:'contacts',component:GuestContactListComponent
      },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactRoutingModule { }
